export const staticNoticias = [
  // Veda News
  {
    imagen: "https://pbs.twimg.com/media/G0lnGjwW8AA596B?format=jpg&name=large",
    url: "https://x.com/CAASIM/status/1966216087818875346",
    titulo: "🚧👷🏻‍♂️¡Los trabajos de bacheo siguen en marcha! ",
    fecha: "",
  },
  {
    imagen: "https://pbs.twimg.com/media/G0ipbX3WUAA44_r?format=jpg&name=large",
    url: "https://x.com/CAASIM/status/1966007606289252824",
    titulo: "🤝🏼 Juan Evel Chávez Trovamala, titular del organismo, acompañó al presidente municipal de Pachuca,",
    fecha: "",
  },
  {
    imagen: "https://pbs.twimg.com/media/G0Qt5ABXoAAf6iY?format=jpg&name=large",
    url: "https://x.com/CAASIM/status/1964745802112520585",
    titulo:
      '🌧️ Evita encharcamientos en tu colonia 🏡',
    fecha: "",
  },
     {
     imagen: "/CAASIM/convocatorias/2026/Transparencia-en-Corto-2026_banner.png",
     url: "/CAASIM/convocatorias/2026/TRANSP EN CORTO_CONVOCATORIA_2026.pdf",
     titulo:
       '"¡XXI CONCURSO NACIONAL TRANSPARENCIA EN CORTO 2026!" ¡Click aqui para consulta las bases!👇',
     fecha: "",
   },
];
